<template lang="html">

  <header class="header row-between" :min="min" :minifybyview="minifybyview"
    :cat="$route.params.id">
      <router-link class="contenedor-logo" to="/"><img src="/static/img/logo.svg" width="160" alt="Logo"></router-link>
    <!-- <nav class="row-end" :show="showmenu">
      <router-link v-for="(cat, key) in categorias" :key="key" :to="$t('enlaces.categoria')+'/'+key">{{cat}}
      </router-link>
    </nav> -->
    <!-- <a @click="showmenu = !showmenu" class="show-menu">
      <span></span><span></span>
    </a> -->
  </header>

</template>

<script lang="js">

  import { mapGetters } from 'vuex';

  export default {
    name: 'app-header',
    mounted() {
      
      $(window).scroll(e => {
        let top = $(window).scrollTop();
        this.min = (top > $(window).height() / 2 - 70);
      });
      this.set();
    },
    data() {
      return {
        min: false,
        minifyin: ['actualidad-ficha','politica-de-cookies','politica-de-privacidad'],
        showmenu: false
      }
    },
    computed: {
      ...mapGetters({
        categorias: 'getCategorias',
      }),
      minifybyview() {
        return (this.minifyin.some(r => this.$route.name == r));
      }
    },
    methods: {
      set() {
        let top = $(window).scrollTop();
        this.min = (top > 200);
        this.supermin = (top > 500);
      }
    },
    watch: {
      '$router'() {
        this.set();
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/parts/header.vue